import React from "react"
import { AppDispatch } from "../../../reduxStore/store"
import {
  ErrorState,
  selectErrorHandler,
  initialState as initialErrorState,
  errorHandlerUpdated,
} from "../errorSlice"
import { useDispatch, useSelector } from "react-redux"
import { Banner } from "../../shared/components/Banner"

interface ErrorBannerProps {
  styleOverrides?: string
}

/**
 * @deprecated Use BannerWithId and bannersWithId state instead. This component uses the legacy errorBanner state.
 */
export const ErrorBanner: React.FC<ErrorBannerProps> = ({ styleOverrides }) => {
  const dispatch: AppDispatch = useDispatch()

  const errorState: ErrorState = useSelector(selectErrorHandler)

  const errorBannerState = errorState.errorBanner

  const handleOnBannerClose = () => {
    const payload: Partial<ErrorState> = {
      errorBanner: initialErrorState.errorBanner,
    }
    dispatch(errorHandlerUpdated(payload))

    errorBannerState.onClose?.()
  }

  return (
    <Banner
      type="error"
      title={errorBannerState.title}
      content={errorBannerState.content}
      isOpen={errorBannerState.isVisible}
      onClose={handleOnBannerClose}
      id="profile-card"
      sticky={true}
      styleOverrides={`${styleOverrides} z-10`}
      contentStyleOverrides="text-base"
      titleStyleOverrides="text-base"
    />
  )
}

export default ErrorBanner
